import React, { PureComponent } from 'react'
import { Table } from 'react-bootstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Lightbox from 'react-image-lightbox'
import { closeLightbox, openLightbox } from '../../actions/lightbox'
import { filterPdf } from '../../utils/filters'
import IdDocumentTrPdf from './id_document_tr_pdf'
import IdDocumentTrImage from './id_document_tr_image'

class IdDocuments extends PureComponent {
  render() {
    const { openLightbox, closeLightbox, isLightboxOpen, photoSrc, data } = this.props

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
          <h5>Documents</h5>
        </div>
        <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
          {this.props.data && this.props.data.length ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Document</th>
                  <th>Type</th>
                  <th>Active</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Updated</th>
                </tr>
              </thead>
              <tbody>
                {data
                  .filter((entry) => !filterPdf(entry))
                  .map((entry, i) => (
                    <IdDocumentTrImage key={i} handleClick={() => openLightbox(entry.document)} entry={entry} />
                  ))}
                {data
                  .filter((entry) => filterPdf(entry))
                  .map((entry, i) => (
                    <IdDocumentTrPdf key={i} entry={entry} />
                  ))}
              </tbody>
            </Table>
          ) : (
            <span>{'N/A'}</span>
          )}
          {isLightboxOpen && <Lightbox mainSrc={photoSrc} onCloseRequest={() => closeLightbox()} />}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isLightboxOpen: state.lightbox.isLightboxOpen,
  photoSrc: state.lightbox.photoSrc,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openLightbox,
      closeLightbox,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(IdDocuments)
